export const QueryKeys = {
    Users: "GroupUsers",
    Fields: "Fields",
    Items: "Items",
    Inventeringar: "Inventeringar"
}